import React from "react";
import styled from "styled-components";
export const Link = ({
  children,
  icon,
  ...props
}) => {
  return React.createElement(LinkWrapper, props, icon && React.createElement(IconWrapper, null, icon), children);
};
export const LinkWrapper = styled.a`
  align-items: center;
  ${props => props.theme.fonts.default}
  font-size: 17px;
  font-weight: 600;
  color: ${props => props.theme.colors.action};
  display: flex;
  line-height: 22px;
  text-decoration: none;

  &:hover,
  &:focus {
    color: ${props => props.theme.colors.linkHover};
    cursor: pointer;
    text-decoration: underline;
  }

  &[disabled] {
    color: ${props => props.theme.colors.linkDeleteDisabled};
    pointer-events: none;
    text-decoration: none;
    svg g {
      fill: ${props => props.theme.colors.linkDeleteDisabled};
    }
  }
`;
export const LinkReverse = styled(Link)`
  color: #ffffff;
  &:hover,
  &:focus {
    color: #ffffff;
  }
`;
const IconWrapper = styled.div`
  display: flex;
  margin-right: 8px;
`;